/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";

import ConfirmationBox from "../../../components/common/ConfirmationBox";
import Footer from "../../../components/common/Footer";
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import SubHeading from "../../../components/common/SubHeading";

import { FaRegCopy } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { SlOptions } from "react-icons/sl";
import { Button, Col, Row, Space, Table, Dropdown } from "antd";

import "./AgreementTemplates.css";

const templates = [
  { id: 1, name: "Current Owner - New Property Addendum" },
  { id: 2, name: "Residentail Property Management Template" },
];

const templates2 = [
  { id: 1, name: "Current Owner - New Property Addendum" },
  { id: 2, name: "Residentail Property Management Template" },
];

const templates3 = [
  { id: 1, name: "Landlord_Tenant_Info_Pamphlet__11-2014_.pdf" },
];

const AgreementTemplatesRightBar = [];

function AgreementTemplates() {
  const [templatesData, setTemplatesData] = useState(templates);
  const [templatesDataTwo, setTemplatesDataTwo] = useState(templates2);
  const [templatesDataThree, setTemplatesDataThree] = useState(templates3);
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);
  const [isConfirmationBoxTwoOpen, setIsConfirmationBoxTwoOpen] = useState(false);
  const [isConfirmationBoxThreeOpen, setIsConfirmationBoxThreeOpen] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [templateTwoName, setTemplateTwoName] = useState("");
  const [templateThreeName, setTemplateThreeName] = useState("");
  const [recordId, setRecordId] = useState(0);
  const [recordTwoId, setRecordTwoId] = useState(0);
  const [recordThreeId, setRecordThreeId] = useState(0);

  const setData = (record) => {
    setRecordId(record.id);
    setTemplateName(record.name);
  };

  const setDataTwo = (record) => {
    setRecordTwoId(record.id);
    setTemplateTwoName(record.name);
  };

  const deleteTemplateDataThree = (record) => {
    const filteredTemplatesData = templatesDataThree.filter((template) => {
      return template.id !== record;
    });

    setTemplatesDataThree(filteredTemplatesData);
    setIsConfirmationBoxThreeOpen(false);
  };

  const deleteTemplateDataTwo = (record) => {
    const filteredTemplatesData = templatesDataTwo.filter((template) => {
      return template.id !== record;
    });

    setTemplatesDataTwo(filteredTemplatesData);
    setIsConfirmationBoxTwoOpen(false);
  };

  const deleteTemplateData = (record) => {
    const filteredTemplatesData = templatesData.filter((template) => {
      return template.id !== record;
    });

    setTemplatesData(filteredTemplatesData);
    setIsConfirmationBoxOpen(false);
  };

  function handleMenuClick({ key }) {
    console.log(key);
    if (Number(key) === 2) {
      setIsConfirmationBoxOpen(true);
    }
  }

  function handleMenuTwoClick({ key }) {
    console.log(key);
    if (Number(key) === 2) {
      setIsConfirmationBoxTwoOpen(true);
    }
  }

  function handleDelete(record) {
    setIsConfirmationBoxThreeOpen(true);
    setRecordThreeId(record.id);
    setTemplateThreeName(record.name);
  }

  const items = [
    {
      key: "1",
      icon: <FaRegCopy />,
      label: "Copy",
    },
    {
      key: "2",
      icon: <RiDeleteBin6Line />,
      label: "Delete",
    },
  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <span className="onclick-text">{text}</span>,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => {
        return (
          <Dropdown
            menu={{
              items,
              onClick: handleMenuClick,
            }}
            onClick={() => setData(record)}
            trigger={["click"]}
          >
            <a href="nothing"
              onClick={(e) => e.preventDefault()}
              style={{ textDecoration: "none" }}
            >
              <Space>
                Options
                <SlOptions />
              </Space>
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const columns2 = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <span className="onclick-text">{text}</span>,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => {
        return (
          <Dropdown
            menu={{
              items,
              onClick: handleMenuTwoClick,
            }}
            onClick={() => setDataTwo(record)}
            trigger={["click"]}
          >
            <a href="nothing"
              onClick={(e) => e.preventDefault()}
              style={{ textDecoration: "none" }}
            >
              <Space>
                Options
                <SlOptions />
              </Space>
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const columns3 = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <span className="onclick-text">{text}</span>,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <Button
          type="link"
          className="delete"
          onClick={() => handleDelete(record)}
        >
          Delete
        </Button>
      ),
    },
  ];

  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="Management Agreement Templates" />
          <Row>
            <Col span={24}>
              <Table
                columns={columns}
                dataSource={templatesData}
                rowKey={(obj) => obj.id}
              />
            </Col>
          </Row>
          <div className="addendum-templates">
            <SubHeading subHeading="Addendum Templates" />
            <Row>
              <Col span={24}>
                <Table
                  columns={columns2}
                  dataSource={templatesDataTwo}
                  rowKey={(obj) => obj.id}
                />
              </Col>
            </Row>
          </div>
          <div className="addendum-templates">
            <SubHeading subHeading="Attachments" />
            <Row>
              <Col span={24}>
                <Table
                  columns={columns3}
                  dataSource={templatesDataThree}
                  rowKey={(obj) => obj.id}
                />
              </Col>
            </Row>
          </div>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={AgreementTemplatesRightBar} />
      </div>
      {isConfirmationBoxOpen ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
          <h2>Please Confirm</h2>
          <p className="message">
            Are you sure you want to delete the {templateName} portfolio?
          </p>
          <div className="action-buttons">
            <button
              className="red"
              onClick={() => deleteTemplateData(recordId)}
            >
              Deleted
            </button>
            <button
              className="cancel-btn"
              onClick={() => setIsConfirmationBoxOpen(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
      {isConfirmationBoxTwoOpen ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxTwoOpen}>
          <h2>Please Confirm</h2>
          <p className="message">
            Are you sure you want to delete the {templateTwoName} portfolio?
          </p>
          <div className="action-buttons">
            <button
              className="red"
              onClick={() => deleteTemplateDataTwo(recordTwoId)}
            >
              Deleted
            </button>
            <button
              className="cancel-btn"
              onClick={() => setIsConfirmationBoxTwoOpen(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
      {isConfirmationBoxThreeOpen ? (
        <ConfirmationBox
          setIsConfirmationBoxOpen={setIsConfirmationBoxThreeOpen}
        >
          <h2>Please Confirm</h2>
          <p className="message">
            Are you sure you want to delete the {templateThreeName} portfolio?
          </p>
          <div className="action-buttons">
            <button
              className="red"
              onClick={() => deleteTemplateDataThree(recordThreeId)}
            >
              Deleted
            </button>
            <button
              className="cancel-btn"
              onClick={() => setIsConfirmationBoxThreeOpen(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
    </>
  );
}

export default AgreementTemplates;
